import { render } from "./cabinet.vue?vue&type=template&id=40f645ce&scoped=true&ts=true"
import script from "./cabinet.vue?vue&type=script&lang=ts"
export * from "./cabinet.vue?vue&type=script&lang=ts"

import "./cabinet.vue?vue&type=style&index=0&id=40f645ce&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f645ce"]])

export default __exports__